import type { AdminResource } from '@mds/shared/types/resource';

/**
 * A room's booking run and price, as the admin works them out while picking slots. The slot
 * board questions themselves are in `@mds/shared/lib/booking-slots`.
 */

const SLOT_MINUTES = 60;

/** A room's shortest bookable run, in minutes — one slot unless it asks for more. */
export const minRun = (r: AdminResource) => r.minimumBookingMinutes ?? SLOT_MINUTES;

/**
 * What a run of minutes costs in a room billed by the hour, in cents. Rooms
 * carry an `hour` rate by the API's own rule, so the hourly amount scales.
 *
 * Shown while the run is being picked. The booking itself is priced by the
 * server from the rate card it snapshots, which is the figure that counts.
 */
export const priceFor = (r: AdminResource, minutes: number) =>
  Math.round((r.rate.amountMinor * minutes) / 60);
